import { render, staticRenderFns } from "./cell-organization-role.vue?vue&type=template&id=7c7c5057&scoped=true"
import script from "./cell-organization-role.ts?vue&type=script&lang=ts&external"
export * from "./cell-organization-role.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-organization-role.vue?vue&type=style&index=0&id=7c7c5057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c5057",
  null
  
)

export default component.exports